<script lang="ts">
	//Services
	import { format } from '../../../../../services/i18n';
	//Helpers
	import { formatSnakeCaseToTitle } from '../../../../../helpers/utilities';
	//Design system components
	import { Container, Radio, Text } from '@Shelly/shelly-design-system';
	import { beforeUpdate } from 'svelte';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';
	import SettingGuide from '../../../SettingGuide.svelte';
	//Types
	import type { InputOutputOptions } from './input_output_types';

	export let typeValue: string,
		modeValue: string,
		_modeValue: string,
		buttonModeOptions: InputOutputOptions,
		reactiveStateValue: string;
	// typeValue - relay will be button or switch
	// modeValue - the action of the switch/ button

	const setButtonMode = (_modeValue) => {
		modeValue = _modeValue;
	};

	let disabled = {};

	const isOptionUnavailable = (key: string, option: InputOutputOptions[string]) =>
		(typeValue !== 'switch' &&
			reactiveStateValue === 'match_input' &&
			['follow', 'flip'].includes(key)) ||
		(option?.type !== typeValue && option?.type !== 'any');

	beforeUpdate(() => {
		//this lifecycle is going to evaluated every time when typeValue is changed
		//this "disabled" object is changed with new values for every type option
		const nextDisabled = {};
		Object.entries(buttonModeOptions).forEach((option, i) => {
			nextDisabled[i] = isOptionUnavailable(option[0], option[1]);
		});
		disabled = nextDisabled;

		let selectedTypeIndex = Object.keys(buttonModeOptions).indexOf(modeValue);
		//selectedTypeIndex is the index of the previous selected type option
		let isSelectedTypedDisabled = disabled[selectedTypeIndex];
		//isSelectedTypedDisabled checks if the previous selected index is enabled or disabled
		//if is false, then this means that is valid option for the button/switch
		// if not, we have to find and select first available option

		let availableIndexes = [];
		let firstAvailableOption;

		if (isSelectedTypedDisabled) {
			Object.entries(disabled).forEach(([key, value]) => {
				if (!value) {
					//record all available indexes
					availableIndexes.push(key);
				}
			});
			// buttonModeOptions are all relay type options represent in object with keys, keys represent the types
			// availableIndexes[0] returns first available index(0, 1, or 2 and so on)
			// Object.keys(buttonModeOptions)[availableIndexes[0]] select first available type
			firstAvailableOption = Object.keys(buttonModeOptions)[availableIndexes[0]];
			setButtonMode(firstAvailableOption);
		}
	});
</script>

{#if $showNewLayout}
	<div>
		<Text class="text-bold mb-xs">
			{formatSnakeCaseToTitle($format('btn_mode_label'))}
		</Text>
		<SettingGuide
			text={$format('settings_guide_relay_type', {
				default:
					'Choose how the wall switch or button drives the output — toggle, momentary, edge, detached, or activation.',
			})}
		/>
		{#each Object.entries(buttonModeOptions) as option, i (option[0])}
			{#if !disabled[i]}
				<Radio
					size="m"
					bind:selected={_modeValue}
					value={option[0]}
					class="mb-xs"
					on:click={() => setButtonMode(option[0])}
					id={`radio-button-mode-${option[0]}`}
					info={option[1]?.description}
				>
					{option[1]?.title}
				</Radio>
			{/if}
		{/each}
	</div>
{:else}
	<Container type="base" class="mb-s" padding="xs">
		<Text class="text-bold mb-s">
			{formatSnakeCaseToTitle($format('btn_mode_label'))}
		</Text>
		{#each Object.entries(buttonModeOptions) as option, i (option[0])}
			<Radio
				size="m"
				bind:selected={_modeValue}
				value={option[0]}
				class="mb-s"
				disabled={disabled[i]}
				on:click={() => setButtonMode(option[0])}
				id="radio-g6qfm71"
			>
				{option[1]?.text}
			</Radio>
		{/each}
	</Container>
{/if}
